export default __webpack_public_path__ + "static/media/greyBgVideo@3x.7bae4aa0.png";